// import "./TFDAccelerateSchools.css";
import "./AccelerateGlobal.css";

import { Link } from "react-router-dom";
import React from "react";

export default function TFDAccelerateSchools() {
  return (
    <div className="tfd-accelerate-schools-page">
      {/* HERO SECTION */}
      <section className="tf-hero-schools">
        <div className="hero-image-wrap">
          <img
            src="/images/accelerate/schools-hero.jpg"
            alt="Accelerate Schools Hero"
            className="hero-bg-image"
          />
          <div className="overlay-dark" />
          <div className="hero-content themeflat-container">
            <h1 className="hero-title wow fadeInUp animated">
              TFD ACCELERATE Schools
            </h1>
            <p className="hero-subtitle wow fadeInUp animated">
              Empowering school athletes through elite training and holistic development.
            </p>
            <Link to="/contact" className="flat-button wow fadeInUp animated">
              Get Involved
            </Link>
          </div>
        </div>
      </section>

      {/* INFO SECTION */}
      <section className="tf-schools-info main-content">
        <div className="themeflat-container">
          <div className="row align-items-center">
            <div className="col-md-6 wow fadeInLeft animated">
              <div className="title-box title-small-v2">
                <span className="sub-title">Why TFD Accelerate Schools?</span>
                <h2 className="title-section">
                  Elevating School Football Programs
                </h2>
              </div>
              <p className="post">
                TFD Accelerate Schools partners with local educational institutions to bring professional-level football training directly to the school environment. Our program is designed to boost technical skills, tactical understanding, and academic excellence—all while fostering teamwork, discipline, and leadership.
              </p>
              <ul className="list-check">
                <li>
                  <strong>Elite Coaching:</strong> Learn from experienced professionals.
                </li>
                <li>
                  <strong>Customized Training:</strong> Sessions tailored to school athletes.
                </li>
                <li>
                  <strong>Academic Integration:</strong> Balancing sports with study support.
                </li>
                <li>
                  <strong>Holistic Growth:</strong> Building character, discipline, and teamwork.
                </li>
              </ul>
              <Link to="/contact" className="flat-button mt-3">
                Learn More
              </Link>
            </div>
            <div className="col-md-6 wow fadeInRight animated">
              <div className="image-wrapper">
                <img
                  src="/images/accelerate/schools-info.jpg"
                  alt="Schools Training Session"
                  className="image-gr"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="tf-schools-cta main-content">
        <div className="themeflat-container text-center">
          <Link to="/contact" className="flat-button big-cta-button wow fadeInUp animated">
            Partner With Us
          </Link>
        </div>
      </section>
    </div>
  );
}
